import { logout, setSkipped, signInWithCredentials, verifyOtp } from '@/features/login/slice';
import { signInWithSessionToken } from '@/features/login/slice';
import { getConfigValue as getConfig } from '@/helpers/configHelper';

import { createListenerMiddleware } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const userListenerMiddleware = createListenerMiddleware();
const domain = getConfig('cloverSportDomain');
const cookiePrefix = getConfig('cookiePrefix');
const cookieOptions = {
  path: '/',
  secure: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'integration',
  sameSite: 'strict',
  domain: `.${domain}`,
  expires: new Date(Date.now() + 24 * 60 * 60 * 1000) // 24 hours expiration
};

const isGracePeriod = true;

export const setCookie = (name, value) => {
  const prefixedName = `${cookiePrefix}__${name}`;
  let derivedValue = value;
  if (name === 'venue_ids') {
    derivedValue = JSON.stringify(value);
  }
  Cookies.set(prefixedName, derivedValue, cookieOptions);
};

const removeCookie = (name) => {
  const prefixedName = `${cookiePrefix}__${name}`;
  Cookies.remove(prefixedName, cookieOptions);
};

userListenerMiddleware.startListening({
  actionCreator: signInWithCredentials.fulfilled,
  predicate: (action, { getState }) => {
    const state = getState();
    return action.type === 'auth/login/fulfilled' && state.mfa.status === 'complete';
  },
  effect: async (action) => {
    if (isGracePeriod) {
      const { session_token, venue_ids, organization_id } = action.payload;

      if (session_token) {
        setCookie('session_token', session_token);
      }
      if (venue_ids) {
        setCookie('venue_ids', venue_ids);
      }
      if (organization_id) {
        setCookie('org_id', organization_id);
      }
    }
  }
});

userListenerMiddleware.startListening({
  actionCreator: setSkipped,
  effect: async (_, { getState }) => {
    const state = getState();

    const sessionToken = state?.auth?.user?.session_token;
    setCookie('session_token', sessionToken);
  }
});

userListenerMiddleware.startListening({
  actionCreator: logout.pending,
  effect: async () => {
    const cookiesToRemove = ['session_token', 'venue_ids', 'org_id'];
    for (const cookieName of cookiesToRemove) {
      console.log(`Removing cookie: ${cookieName}`);
      removeCookie(cookieName);
    }
  }
});

userListenerMiddleware.startListening({
  actionCreator: signInWithSessionToken.rejected,
  effect: async () => {
    const cookiesToRemove = ['session_token', 'venue_ids', 'org_id'];
    for (const cookieName of cookiesToRemove) {
      console.log(`Removing cookie: ${cookieName}`);
      removeCookie(cookieName);
    }
  }
});

userListenerMiddleware.startListening({
  actionCreator: verifyOtp.fulfilled,
  effect: async (action, { getState }) => {
    const state = getState();

    const sessionToken = action.payload?.session_token || state?.auth?.user?.session_token;
    setCookie('session_token', sessionToken);
  }
});

export default userListenerMiddleware;
